<template>
  <w-flex justify-center align-center v-if="$zutil.role('Al Man')">
    <div class="w-card__content content-hardcode">
      
    </div>
  </w-flex>
  <div class="w-table-wrap">
   <w-flex class="mt4">
        <div class="xs12 text-right">
          <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> Tambah
          </w-button>
        </div>
      </w-flex>
    <table class="w-table" color="light">
      <thead>
        <tr>
          <th class="w-table__header text-left" width="1%">No</th>
          <th class="w-table__header text-left">Tarikh</th>
          <th class="w-table__header text-left">Berat Badan (kg)</th>
         <!--  <th class="w-table__header text-left">Ukuran Lilitan Dada (cm)</th>
          <th class="w-table__header text-left">Tinggi Badan (cm)</th>
          <th class="w-table__header text-left">Panjang Badan (cm)</th> -->
          <!-- <th class="w-table__header text-left">Keterangan</th> -->
          <th class="w-table__header text-left">Tindakan</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row">
            <td class="w-table__cell text-left" colspan="20">Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas" :key="dt.id">
          <tr class="w-table__row">
            <td class="w-table__cell text-left">{{ ind + 1 }}</td>
            <td class="w-table__cell text-left">{{ dt.tarikh }}</td>
            <td class="w-table__cell text-left">{{ dt.berat_badan }}</td>
            <!-- <td class="w-table__cell text-left">{{ dt.lingkar_dada }}</td>
            <td class="w-table__cell text-left">{{ dt.tinggi_badan }}</td>
            <td class="w-table__cell text-left">{{ dt.panjang_badan }}</td>
            <td class="w-table__cell text-left">{{ dt.keterangan }}</td> -->
            <td class="w-table__cell v2 text-left" >

               <w-button class="fs-2"  bg-color="orange-light3" tile @click="edit(item)">
                  <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI
              </w-button>
              &nbsp;  
              <w-button class="fs-2" bg-color="error-dark1" dark tile @click="padam(dt)">
                  <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
              </w-button>
              &nbsp;  
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white"
  >
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Penilaian Prestasi Anak
    </template>
    <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">
      <z-input class="mt4" label="Tarikh *" type="date" v-model="form.tarikh" :validators="[validators.required]" />
      <w-input class="mt4" label="Berat Badan (kg) *" type="number" v-model="form.berat_badan" :validators="[validators.required]"/>
      <!-- <w-input class="mt4" label="Ukuran Lilitan Dada (cm)" type="number" v-model="form.lingkar_dada" />
      <w-input class="mt4" label="Tinggi Badan (cm)" type="number" v-model="form.tinggi_badan" />
      <w-input class="mt4" label="Panjang Badan (cm)" type="number" v-model="form.panjang_badan" />
      <w-input class="mt4" label="Keterangan" type="keterangan" v-model="form.keterangan" /> -->
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Simpan</w-button>
    </template>
  </w-dialog>
</template>

<script>
export default {
  name: "Penilaian Prestasi Anak",
  props: {
    data: [Array, Object],
  },
  data() {
    return {
      form: {
        lingkar_dada: '',
        tinggi_badan: '',
        berat_badan: '',
        panjang_badan: '',
        tarikh: '',
        keterangan: '',
      },
      datas: [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      validators: {
        required: value => !!value || 'Wajib Isi.',
      },
    };
  },
  methods: {
    add() {
      this.dialog.show = true;
      this.form = {
        lingkar_dada: '',
        tinggi_badan: '',
        berat_badan: '',
        panjang_badan: '',
        tarikh: '',
        keterangan: '',
      };
    },
    padam(dt){
      if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
            this.$zcomm.delete('ternakan.perkembangan', this.form)
                .then(res => {
                  //update displayed record
                  this.$zutil.notify("Berjaya dipadam", false);
                  this.getData();
                  // this.$inertia.visit(this.$page.url)
                  // this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
        }
    },
    
    getData() {
      this.$zcomm.get(this.api_service + 'ternakan/perkembangan/' + this.data.id, {}).then(res => {
        this.datas = res;
      });
    },

    submit() {
      if (
        this.form.tarikh &&
        this.form.berat_badan 
        
      ) {
        this.form.ternakan_id = this.data.id;
        this.$zcomm.add('ternakan.perkembangan', this.form)
          .then(res => {
            this.dialog.show = false;
            this.getData();
          })
          .finally(() => {
            this.dialog.loading = false;
          });
      }
    },
    destroy(id) {
      if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
        this.$zcomm.delete('ternakan.perkembangan.destroy', id)
          .then(res => {
            this.getData();
          })
          .finally(() => {});
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
